
<ng-content select="[styleBefore]"></ng-content>

<visual-editor-box appearance="fields" canCollapse>
  <span boxTitle>
    <i class="fas fa-brush w-16 text-center mr-5"></i>
    <span>Appearance</span>
  </span>
  <div>
    <div class="visual-editor-box__input-horizontal">
      <ng-content select="[appearanceBefore]"></ng-content>

      @if (hasBackground()) {
        <label>Background:</label>
        <app-color-input [(value)]="backgroundColor"></app-color-input>
      }

      <ng-content select="[appearanceAfter]"></ng-content>
    </div>
  </div>
</visual-editor-box>

<ng-content select="[styleAfterAppearance]"></ng-content>

<visual-editor-box appearance="fields" canCollapse>
  <span boxTitle>
    <i class="far fa-text-size w-16 text-center mr-5"></i>
    <span>Title</span>
  </span>
  <div>
    <visual-title-style-editor [(style)]="title" (styleChange)="onTitleChanged()" [fontSizeOptions]="FontSizeOptions.title"></visual-title-style-editor>
  </div>
</visual-editor-box>

<visual-editor-box appearance="fields" canCollapse>
  <span boxTitle>
    <span class="d-inline-flex justify-content-between w-100p">
      <span>
        <i class="far fa-text-size w-16 text-center mr-5"></i>
        <span>Subtitle</span>
      </span>
      <span class="visual-style-editor__subtitle-link" (click)="subtitleLinkClick()" [class.disabled]="!titleEnabled()">
        <i class="far fa-pencil-alt w-16 text-center mr-5"></i>
        <span class="text">Edit Text</span>
      </span>
    </span>
  </span>
  <div>
    <visual-title-style-editor [(style)]="subtitle" [fontSizeIsReadonly]="true"
                               [disabled]="!titleEnabled()"></visual-title-style-editor>
  </div>
</visual-editor-box>

<ng-content select="[styleAfter]"></ng-content>
